import { render, staticRenderFns } from "./InputRangWantTotal.vue?vue&type=template&id=b271ec70&scoped=true&"
import script from "./InputRangWantTotal.vue?vue&type=script&lang=js&"
export * from "./InputRangWantTotal.vue?vue&type=script&lang=js&"
import style0 from "./InputRangWantTotal.vue?vue&type=style&index=0&id=b271ec70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b271ec70",
  null
  
)

export default component.exports